import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classes from './ImageGallery.module.scss';

const ImageGallery = (props) => {
  const {
    items = [],
    sliderHeight,
    sliderWidth,
    showAltText,
  } = props;

  const [bigNav, setBigNav] = useState(null);
  const [thumbNav, setThumbNav] = useState(null);
  const [bigImage, setBigImage] = useState(null);
  const [thumbSlider, setThumbSlider] = useState(null);

  useEffect(() => {
    setBigNav(bigImage);
    setThumbNav(thumbSlider);
  }, [bigImage, thumbSlider]);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
  };

  const settingsThumbs = {
    // As defined in requirements, the gallery should show 5 thumbs,
    // however if defined to show 5 and there are less than 5 a bug happens
    slidesToShow: items.length <= 5 ? items.length : 5,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '20px', // responsible to show to the user that are more items hidden
  };

  return (

    <div className={classes.sliderWrapper} style={{ width: `${sliderWidth}` }}>

      <Slider
        {...settingsMain}
        asNavFor={thumbNav}
        ref={(slider) => setBigImage(slider)}
      >

        {items?.map((slide, idx) => (
          <div className={classes.slickSlide} key={idx}>
            <img
              className={classes.slickSlideImage}
              src={slide.imageURI}
              alt={slide.imageAltText}
              style={{ height: `${sliderHeight}` }}
            />
            {showAltText &&
              slide.imageAltText &&
              <div className={classes.slickSlideText}>{slide.imageAltText}</div>}
          </div>
        ))}
      </Slider>

      {items.length > 1 &&
        <div className={classes.thumbnailSliderWrap}>
          <Slider
            {...settingsThumbs}
            asNavFor={bigNav}
            ref={(slider) => setThumbSlider(slider)}
          >
            {items?.map((slide, idx) => (
              <div className={classes.slickSlideThumb} key={idx}>
                <img className={classes.slickSlideImageImgThumb} src={slide.imageURI} alt={slide.imageAltText} />
              </div>
            ))}
          </Slider>
        </div>}
    </div>
  );
};

export default ImageGallery;

const image = PropTypes.shape({
  imageURI: PropTypes.string,
  imageAltText: PropTypes.string,
});

ImageGallery.propTypes = {
  items: PropTypes.arrayOf(image).isRequired,
  sliderHeight: PropTypes.string,
  sliderWidth: PropTypes.string,
  showAltText: PropTypes.bool.isRequired,
};
